<script lang="ts">
    // <SimpleStatus text="API Token" check={initialSettings?.token===''} success="OK" failure="Not found" />
    export let text: string = 'Hello world!';
    export let check: boolean = true;
    export let success: string = 'OK';
    export let failure: string = 'Error';

</script>

<div><pre>{text}...</pre>
</div>
<div class="failure" class:success={check}><pre>{check ? success : failure}</pre></div>

<style>
    .failure {
        color: red;
    }
    .success {
        color: green;
    }
</style>